import React, { Fragment } from "react";
import { Col } from "reactstrap";
import { Alerts, P } from "../../../../AbstractElements";
import { LIGHT_THEME_LISTS } from "../../../../Data/UiKit/Alert";
import { Href } from "../../../../Constant";

const LightThemeRightSection = () => {
  return (
    <Col xl="6">
      <P className="mb-0">Warning Light Alert</P>
      <Alerts className="alert alert-light-warning">
        <P className="txt-warning">{`This is a `}
          <a className="alert-link txt-warning" href={Href}>warning alert</a>
          with an example link. Check it out.
        </P>
      </Alerts>
      {LIGHT_THEME_LISTS.map(({title,color,className}, index) => (
        <Fragment key={index}>
          <P className="mb-0">{title}</P>
          <Alerts color={color}>
            <P className={className}>{`This is a `}
              <a className={`alert-link text-lowercase ${className}`} href={Href}>{title}</a> with an example link. Check it out.
            </P>
          </Alerts>
        </Fragment>
      ))}
    </Col>
  );
};

export default LightThemeRightSection;